import { featuredBlog } from "@/content/featuredBlog";
import Image from "next/image";

export default function FeaturedBlogs() {
  return (
    <div className="mx-auto max-w-8xl px-4 lg:px-8">
      <div className="mx-auto max-w-2xl text-center">
        <h2 className="medium-title">Featured articles from PortalJS blog</h2>
      </div>
      <div className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-6 lg:mx-0 lg:max-w-none lg:grid-cols-3">
        {featuredBlog.map((post) => (
          <article key={post.href} className="flex flex-col items-start justify-between cursor-pointer">
            <a href={post.href} target="_blank">
              <div className="relative w-full aspect-[16/9] sm:aspect-[2/1] lg:aspect-[3/2] rounded-2xl overflow-hidden bg-gray-100">
                <Image
                  src={post?.image || "/assets/images/layout/datopian-logo-black.png"}
                  alt="Case Study Image"
                  fill
                  className="object-cover"
                  sizes="100vw"
                />
                <div className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-gray-900/10" />
              </div>
              <div className="max-w-xl h-full">
                <div className="group relative flex flex-col justify-start h-[8rem]">
                  <h3 className="mt-3 text-lg font-bold text-gray-900 group-hover:text-gray-600 line-clamp-1">
                    <span className="absolute inset-0" />
                    {post.title.length > 52 ? post.title.substring(0, 51) + '...' : post.title}
                  </h3>
                  <p className="mt-5 line-clamp-3  main-text">{post.description}</p>
                </div>
                <div className="relative mt-6 flex items-center gap-x-4 text-start">
                  <div className="flex -space-x-4">
                    {post.authors.map((avatar) => (
                      <Image
                        width={32}
                        height={32}
                        key={avatar}
                        src={"/assets/images/team/" + avatar}
                        alt="Author Image"
                        className="h-10 w-10 rounded-full bg-gray-100 object-center object-cover bypass-filter"
                      />
                    ))}
                  </div>
                  <div className="text-sm leading-6">
                    <time dateTime={post.created} className="text-secgray">
                      {new Date(post.created).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
                    </time>
                  </div>
                </div>
              </div>
            </a>
          </article>
        ))}
      </div>
    </div>
  )
}
